var map = {
	"./admin.svg": "BlLF",
	"./all.svg": "QcK0",
	"./category.svg": "3HFE",
	"./city.svg": "WTnP",
	"./country.svg": "nnnf",
	"./data.svg": "RUrO",
	"./date.svg": "Ve8B",
	"./download-limit.svg": "GJ6p",
	"./download.svg": "+H2/",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./global.svg": "n/DV",
	"./journal.svg": "UVyV",
	"./link.svg": "KgwQ",
	"./lock.svg": "FnAU",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./people-analysis.svg": "1nV/",
	"./pie-graph.svg": "B4AJ",
	"./plane.svg": "yLYP",
	"./research-black.svg": "+v55",
	"./research.svg": "zJYT",
	"./share.svg": "BDVe",
	"./table.svg": "oSYw",
	"./teacher.svg": "CLrc",
	"./tree.svg": "3eCm",
	"./unlock.svg": "JNNJ",
	"./user.svg": "VdD3",
	"./visit.svg": "KSvl",
	"./visitchange.svg": "0eXq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 5